import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Programs from "../pages/programs/page";
import BachelorPrograms from "../pages/programs/bachelor/page";
import MasterPrograms from "../pages/programs/master/page";
import Admissions from "../pages/admissions/page";
import FutureStudents from "../pages/admissions/future/page";
import InternationalStudents from "../pages/admissions/international/page";
import Scholarships from "../pages/admissions/scholarships/page";
import StudentExperience from "../pages/student-experience/page";
import Campuses from "../pages/campuses/page";
import Library from "../pages/library/page";
import Donate from "../pages/donate/page";
import StaffDirectory from "../pages/staff-directory/page";
import Closures from "../pages/closures/page";
import Research from "../pages/research/page";
import Partnerships from "../pages/partnerships/page";
import Campus from "../pages/campus/page";
import Contact from "../pages/contact/page";
import News from "../pages/news/page";
import NewsDetail from "../pages/news/NewsDetail";
import WhyEstad from "../pages/about/why-estad/page";
import ProgramDetail from "../pages/programs/detail/page";
import MainLayout from "../components/feature/MainLayout";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/about", element: <About /> },
      { path: "/programs", element: <Programs /> },
      { path: "/programs/bachelor", element: <BachelorPrograms /> },
      { path: "/programs/master", element: <MasterPrograms /> },
      { path: "/programs/:slug", element: <ProgramDetail /> },
      { path: "/admissions", element: <Admissions /> },
      { path: "/admissions/future", element: <FutureStudents /> },
      { path: "/admissions/international", element: <InternationalStudents /> },
      { path: "/admissions/scholarships", element: <Scholarships /> },
      { path: "/about/why-estad", element: <WhyEstad /> },
      { path: "/student-experience", element: <StudentExperience /> },
      { path: "/campuses", element: <Campuses /> },
      { path: "/library", element: <Library /> },
      { path: "/donate", element: <Donate /> },
      { path: "/staff-directory", element: <StaffDirectory /> },
      { path: "/closures", element: <Closures /> },
      { path: "/research", element: <Research /> },
      { path: "/partnerships", element: <Partnerships /> },
      { path: "/campus", element: <Campus /> },
      { path: "/contact", element: <Contact /> },
      { path: "/news", element: <News /> },
      { path: "/news/:slug", element: <NewsDetail /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;